export enum BackgroundWorkType {
    ScoresCalculation,
    RankingsGeneration,
    RankingsUpdate,
    ImportAnswerCardFile
}
